import { GridPaginationModel } from '@mui/x-data-grid-pro';

import {
	BASE_PAGINATION_MODEL,
	INVOICES_DEFAULT_PAGINATION_MODEL,
} from '~constants/paginationModels';
import { ScreenTypes } from '~constants/screenTypes';

export const getDefaultPaginationModelByType = (
	screenType: ScreenTypes,
): GridPaginationModel => {
	switch (screenType) {
		case ScreenTypes.INVOICES:
			return INVOICES_DEFAULT_PAGINATION_MODEL;

		default:
			return BASE_PAGINATION_MODEL;
	}
};
